import { useState } from "react";
import { PageTitle } from "../../layout/PageTitle";
import { createListStore } from "../../common/listStore";
import { renderListStore } from "../../common/listStoreUi";

export function WarehousesListPage() {
    const [useWarehousesStore] = useState(() => createListStore<WarehouseDto>({
        path: "settings/warehouses",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "code", label: "Code", width: 100 },
            { column: "description", label: "Name", width: 300 },
            { column: "isActive", label: "Active", width: 100 },
        ],
    }));

    return <>
        <PageTitle title="Warehouses" />
        {renderListStore(useWarehousesStore, {
        })}
    </>;
}

interface WarehouseDto {
    id: number;
    code: string;
    description: string;
    isActive: boolean;
}
